import React, { ReactNode, useEffect, useState } from 'react';
import StatusLabel from '../UtilityHelpers/StatusLabel';
import NamePopOver from '../UtilityHelpers/NamePopOver';

import { useUtils } from '../../hooks/useUtils';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../hooks/useAuth";

import { Tooltip } from "flowbite-react";

import { IoMdCheckmarkCircle } from "react-icons/io";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { MdFormatListBulletedAdd } from "react-icons/md";
import { MdCancel } from "react-icons/md";
import { FaCartShopping } from "react-icons/fa6";
import { FaRegCreditCard } from "react-icons/fa";
import { FaTruckFast } from "react-icons/fa6";
import { MdEditSquare } from "react-icons/md";

type RequestListTableTypeProps = {
    tableHeader: string,
    items: any,
    handleChangeToApprove: (itemID: number) => void,
    handleChangeToDissapprove: (itemID: number) => void,
    handleChangeToWaitlist: (itemID: number) => void,
    handleChangeStatus: (itemID: number, status: string) => void
    statusType: string
}

const RequestListTable = ({tableHeader, items, handleChangeToApprove, handleChangeToDissapprove, handleChangeToWaitlist, handleChangeStatus, statusType}: RequestListTableTypeProps) => {
    const [isLimitedOpex, setIsLimitedOpex] = useState(false);
    const helperUtils = useUtils();
    const navigate = useNavigate();    
    const auth = useAuth();

    console.log(statusType);

    const renderViewRequest = (id: number) => {
        if (auth?.roles?.find(role => ["500"]?.includes(role))) {
            return (
                <Tooltip content="Edit Request" style="light" arrow={false}>
                    <button className="hover:text-primary">
                        <MdEditSquare className='text-xl' onClick={() => navigate('/admin/view-request?id=' + id)} />
                    </button>                  
                </Tooltip>                
            )
        } else {
            return (
                <Tooltip content="View Request" style="light" arrow={false}>
                    <button className="hover:text-primary">
                        <MdOutlineRemoveRedEye className='text-xl' onClick={() => navigate('/approver/view-request?id=' + id)} />
                    </button>                  
                </Tooltip>
            )
        }
    }


    useEffect(() => {
        if (auth?.roles?.find(role => ["200"]?.includes(role))) {
            setIsLimitedOpex(true);
        }
    }, [])
    return (
        <div className="col-span-12 rounded-sm border border-stroke bg-white px-5 pt-7.5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5">
            <h5 className="text-xl font-semibold text-black dark:text-white">
                {tableHeader}
            </h5>
            <div className='overflow-auto'>
                <table className="w-full table-auto mt-5">
                <thead>
                    <tr className="bg-gray-2 text-left dark:bg-meta-4">
                    <th className="min-w-[80px] py-4 px-4 font-medium text-black dark:text-white xl:pl-11">
                        ID
                    </th>
                    <th className="min-w-[220px] py-4 px-4 font-medium text-black dark:text-white xl:pl-11">
                        Names
                    </th>
                    <th className="min-w-[150px] py-4 px-4 font-medium text-black dark:text-white">
                        Title
                    </th>              
                    <th className="min-w-[150px] py-4 px-4 font-medium text-black dark:text-white">
                        Description
                    </th>
                    <th className="min-w-[150px] py-4 px-4 font-medium text-black dark:text-white">
                        Date
                    </th>
                    <th className="min-w-[120px] py-4 px-4 font-medium text-black dark:text-white">
                        Status
                    </th>
                    <th className="min-w-[120px] py-4 px-4 font-medium text-black dark:text-white">
                        Total Cost
                    </th>
                    <th className="py-4 px-4 font-medium text-black dark:text-white">
                        Actions                
                    </th>
                    </tr>
                </thead>
                <tbody>
                    
                {items.map((item:any, key:number) => {

                        const descriptionMaxLength = 50;
                        const truncatedDescription = item.description.length > descriptionMaxLength
                        ? `${item.description.substring(0, descriptionMaxLength)}...`
                        : item.description;

                        return (
                        <tr key={key}>
                            <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                            <p className="text-black dark:text-white">
                                {item.id}
                            </p>
                            </td>                
                            <td className="border-b border-[#eee] py-5 px-4 pl-9 dark:border-strokedark xl:pl-11">
                            <h5 className="font-medium text-black dark:text-white">
                                {
                                item.members.map((member:any) => {
                                    return <NamePopOver memberData={member} />                                         
                                })
                            }
                            </h5>
                            </td>
                            <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                            <p className="text-primary hover:text-blue-400 dark:text-primary dark:hover:text-blue-400 cursor-pointer" onClick={() =>navigate('/approver/view-request?id=' + item.id)}>
                                {item.title}
                            </p>
                            </td>                
                            <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                            <p className="text-black dark:text-white">
                                {truncatedDescription}
                            </p>
                            </td>
                            <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                            <p className="text-black dark:text-white">
                                {item.submitted_on}
                            </p>
                            </td>
                            <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark text-center">
                            <StatusLabel statusLabel={item.status} />
                            </td>
                            <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                            <p className="text-green-600 dark:text-green-400 text-right">
                                {helperUtils.convertToMoney(item.total_cost)}
                            </p>
                            </td>
                            <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                            <div className="flex items-center space-x-3.5">
                                { ((item.status === "Waitlisted") || (item.status === "New") && isLimitedOpex && (item.total_cost <= 200)) && <Tooltip content="Approve" style="light" arrow={false}>
                                <button className="hover:text-primary">
                                    <IoMdCheckmarkCircle className='text-xl' onClick={() => handleChangeToApprove(item.id)} />                    
                                </button>
                                </Tooltip>}
                                { ((item.status === "Waitlisted") || (item.status === "New") && !isLimitedOpex) && <Tooltip content="Approve" style="light" arrow={false}>
                                <button className="hover:text-primary">
                                    <IoMdCheckmarkCircle className='text-xl' onClick={() => handleChangeToApprove(item.id)} />                    
                                </button>
                                </Tooltip>}                                
                                { ((item.status === "Waitlisted") || (item.status === "New") && !isLimitedOpex) && <Tooltip content="Decline" style="light" arrow={false}>
                                <button className="hover:text-primary">
                                    <MdCancel className='text-xl' onClick={() => handleChangeToDissapprove(item.id)} />                    
                                </button>
                                </Tooltip>}                                
                                { (item.status === "New" && !isLimitedOpex) && <Tooltip content="Waitlist" style="light" arrow={false}>
                                <button className="hover:text-primary">
                                    <MdFormatListBulletedAdd className='text-xl' onClick={() => handleChangeToWaitlist(item.id)} />
                                </button>
                                </Tooltip>}
                                { (item.status === "Approved") && <Tooltip content="Order" style="light" arrow={false}>
                                <button className="hover:text-primary">
                                    <FaCartShopping className='text-xl' onClick={() => handleChangeStatus(item.id, "Ordered")} />
                                </button>
                                </Tooltip>}
                                { ((item.status === "Approved") || (item.status === "Ordered")) && <Tooltip content="Purchase" style="light" arrow={false}>
                                <button className="hover:text-primary">
                                    <FaRegCreditCard className='text-xl' onClick={() => handleChangeStatus(item.id, "Purchased")} />
                                </button>
                                </Tooltip>}
                                { ((item.status === "Approved") || (item.status === "Ordered") || (item.status === "Purchased") ) && <Tooltip content="Deliver" style="light" arrow={false}>
                                <button className="hover:text-primary">
                                    <FaTruckFast className='text-xl' onClick={() => handleChangeStatus(item.id, "Delivered")} />
                                </button>
                                </Tooltip>}
                                {
                                    renderViewRequest(item.id)
                                }
                            </div>
                            </td>
                        </tr>
                        )}
                )}

                    
                </tbody>
                </table>
            </div>
        </div>
    )
}

export default RequestListTable;